import { removeHtmlTagsFromString } from "shared/utils";

const customText = (prev: any, curr: any, columnId: any, asc: any) => {
  if (prev.values[columnId] === curr.values[columnId]) {
    return 0;
  }
  if (prev.values[columnId] === null || prev.values[columnId] === undefined) {
    return asc ? -1 : 1;
  }
  if (curr.values[columnId] === null || curr.values[columnId] === undefined) {
    return asc ? 1 : -1;
  }

  return prev.values[columnId].localeCompare(curr.values[columnId]);
};

const customNumber = (prev: any, curr: any, columnId: any, asc: any) => {
  if (prev.values[columnId] === curr.values[columnId]) {
    return 0;
  }
  if (prev.values[columnId] === null) {
    return asc ? -1 : 1;
  }
  if (curr.values[columnId] === null) {
    return asc ? 1 : -1;
  }

  return prev.values[columnId] - curr.values[columnId];
};

const amount = (prev: any, curr: any, columnId: any) => {
  if (prev.values[columnId]?.value > curr.values[columnId]?.value || curr.values[columnId] === null) {
    return 1;
  } else if (prev.values[columnId]?.value < curr.values[columnId]?.value || prev.values[columnId] === null) {
    return -1;
  } else {
    return 0;
  }
};

export function coreSort(a: any, b: any, asc: boolean): number | undefined {
  if (a === b) {
    return 0;
  }
  if (a === null || a === undefined) {
    return asc ? -1 : 1;
  }
  if (b === null || b === undefined) {
    return asc ? 1 : -1;
  }
}

export function coreSortHtml(a: any, b: any) {
  return removeHtmlTagsFromString(a).localeCompare?.(removeHtmlTagsFromString(b)) || 0;
}

export const htmlText = (prev: any, curr: any, columnId: any, asc: any) => {
  const result = coreSort(prev.values[columnId], curr.values[columnId], asc);
  if (result !== undefined) {
    return result;
  } else {
    return coreSortHtml(prev.values[columnId], curr.values[columnId]);
  }
};

export const defaultSortTypes = {
  alphanumeric: customText,
  customText,
  customNumber,
  amount: amount,
  htmlText
};
